export default
{
    MIN_DURATION: 1250
}



// WEBPACK FOOTER //
// ./src/scripts/constants/transition.js